export enum TipoParametroEnum {

  ValorProduto = 1,
  ObrigacaoAplicadaInferior = 2,
  ObrigacaoAplicadaSuperior = 3,
  ObrigacaoAplicada = 4,
  MultiplicadorCartaCredito = 18,
  PercentualLimite = 19,
  MultiplicadorCartaCreditoTecnac = 20,
  PercentualLimiteTecnac = 21,
  MultiplicadorPadis = 22,
  PercentualPadis = 23,
  ObrigacaoAplicada_10356 = 24,
  MultiplicadorAnual = 25,
  PercentualLimiteAnual = 26,
  DenominadorPdic = 27
}
